import { Skeleton } from "antd"

interface BoardLoadingProps {
  style?: any
}

export function BoardLoading({ style }: BoardLoadingProps) {
  return (
    <div style={style}>
      <Skeleton style={{ width: "100%" }} active></Skeleton>
      <Skeleton style={{ width: "100%" }} active></Skeleton>
      <Skeleton style={{ width: "100%" }} active></Skeleton>
    </div>
  )
}
